import { Alert } from '@trussworks/react-uswds';
import { useFormContext } from 'react-hook-form';
import { getFormContentVisibility } from '@components/dynamic-form/helpers';
import { MarkdownRenderer } from '@src/app-components/markdown-renderer/MarkdownRenderer';
import classNames from 'classnames';
import Question from './Question';
import './dynamicForm.scss';
import { getEnvironmentVisibility } from '../environment-visibility/EnvironmentVisibility';
import { InputMap } from './inputMap';

const showDebugInfo = getEnvironmentVisibility({ mode: 'show', local: true });

const Section = ({
  allowAutoScroll,
  onChange = () => {},
  componentID,
  isReadOnly,
  questionsById,
  sectionData,
  stepNo,
}) => {
  const { watch } = useFormContext();
  const formDocuments = [];

  const formValues = watch();

  const anyQuestionsVisible = sectionData?.questions?.some((question) =>
    getFormContentVisibility({
      formValues,
      parentThreads: question.parentThreads || [],
    })
  );

  const sectionStyles = classNames('dynamic-section', {
    hidden: !anyQuestionsVisible,
  });

  const label = showDebugInfo ? (
    <>
      <b>s{sectionData.sectionId}</b>: &nbsp;
      <MarkdownRenderer displayInline text={sectionData.sectionName} />
    </>
  ) : (
    <MarkdownRenderer displayInline text={sectionData.sectionName} />
  );

  return (
    <section className={sectionStyles}>
      <h3>{label}</h3>
      {sectionData?.additionalInfo && (
        <Alert className='dynamic-section-info callout' noIcon slim type='info' headingLevel='h4'>
          <MarkdownRenderer text={sectionData.additionalInfo} />
        </Alert>
      )}
      {sectionData?.questions?.map((question, i) => (
        <Question
          allowAutoScroll={allowAutoScroll}
          componentID={componentID}
          formDocuments={formDocuments}
          formId={sectionData.formId}
          inputMap={InputMap}
          isReadOnly={isReadOnly}
          key={`${question.questionId}_${i}`}
          onChange={onChange}
          questionsById={questionsById}
          questionData={question}
          stepNo={stepNo}
        />
      ))}
    </section>
  );
};

export default Section;
